import { render, staticRenderFns } from "./MspValutazione.vue?vue&type=template&id=2aabe9e4"
import script from "./MspValutazione.vue?vue&type=script&lang=js"
export * from "./MspValutazione.vue?vue&type=script&lang=js"
import style0 from "./MspValutazione.vue?vue&type=style&index=0&id=2aabe9e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports